import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Box, useMediaQuery, Divider, Typography } from '@mui/material';
import SocialIcons from '../../shared/components/SocialIcons';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
// import { theme } from '../Template';
import { useCompanyData } from '../contexts/DataContext';
import image from 'src/assets/images/templates/world-map.png';
import Logo from 'src/assets/images/white-logo.png';
import Logo2 from 'src/assets/images/logo.png';
import CardIcons from 'src/assets/images/cardIcons.png'
import MadaIcon from 'src/assets/images/madaCard.jpeg';

// payment card icons
import MasterCardImg from 'src/assets/images/payment_cards/Mastercard.png';
import VisaCardImg from 'src/assets/images/payment_cards/Visa.png';
import MadaCardImg from 'src/assets/images/payment_cards/Mada.png';
import ApplePayCardImg from 'src/assets/images/payment_cards/Applepay.png';
import GPayCardImg from 'src/assets/images/payment_cards/Gpay.png';
import AECardImg from 'src/assets/images/payment_cards/AE.png';
import STCCardImg from 'src/assets/images/payment_cards/STC.png';
import BankCardImg from 'src/assets/images/payment_cards/Bank.png';
import TabbyCardImg from 'src/assets/images/payment_cards/Tabby.png';
import TamaraCardImg from 'src/assets/images/payment_cards/Tamara.png';
import FawryCardImg from 'src/assets/images/payment_cards/Fawry.png';
import KNCardImg from 'src/assets/images/payment_cards/KN.png';
import VFCardImg from 'src/assets/images/payment_cards/VF.png';
import WalletCardImg from 'src/assets/images/payment_cards/Wallet.png';

const iconList = {
  'Mastercard': MasterCardImg,
  'Visa': VisaCardImg,
  'Mada': MadaCardImg,
  'Applepay': ApplePayCardImg,
  'Gpay': GPayCardImg,
  'AE': AECardImg,
  'STC': STCCardImg,
  'Bank': BankCardImg,
  'Tabby': TabbyCardImg,
  'Tamara': TamaraCardImg,
  'Fawry': FawryCardImg,
  'KN': KNCardImg,
  'VF': VFCardImg,
  'Wallet': WalletCardImg
}

const LongStyleFooter = ({theme}) => {
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { data } = useCompanyData();
  const { pathname:url } = useLocation();
  const { id:pathId } = useParams();
  const { t, isRTL, companyEmail, companyDomain, termsLink, refundLink, privacyLink } = data || {};
  const companyId = data.companyData?.id;
  const { footer, footerCopyright, footerEmail, footerPhone, footerAddress } = data || {};
  const {
    footerBackgroundColor,
    footerFontColor,
    visiblePaymentIcon=true,
    visibleMenu,
    visibleTerms,
    visiblePrivacy,
    visibleRefund,
    visiblePhone,
    visibleEmail,
    visibleSocialMedia,
    visibleAddress,
    paymentList=['Mastercard','Visa']
  } = footer || {};
  const visibleMap = visibleAddress !== undefined ? visibleAddress : true;
  const menuList = data?.menuList?.length > 2 ? Array.from(data?.menuList) : [];
  const navItem =  [{title:t && t('companyPage.home'),link: companyDomain ? '/' : `/${pathId}`},{title:t && t('companyPage.services'),link: companyDomain ? '/temp/services' : `/${pathId}/temp/services`},{title:t && t('companyPage.contact'),link: companyDomain ? `/temp/contact` : `/${pathId}/temp/contact`}]
  const navItem2 = Array.from(navItem)?.splice(0,1);
  const footerLinks = [
    {...((termsLink && visibleTerms) && {...{isPath:true,link:companyDomain ? '/temp/terms' : `/${pathId}/temp/terms`,label:t('company_setting.page-setting.terms')}})},
    {...((privacyLink && visiblePrivacy) && {...{isPath:true,link:companyDomain ? '/temp/privacy' : `/${pathId}/temp/privacy`,label:t('company_setting.page-setting.policy')}})},
    {...((refundLink && visibleRefund) && {...{isPath:true,link:companyDomain ? '/temp/refund_policy' : `/${pathId}/temp/refund_policy`,label:t('company_setting.page-setting.refund')}})},
  ];
  const {
    address,
    phoneNumber,
    twitterPage,
    youtube,
    facebookPage,
    instagramPage,
    linkedin,
    tiktok,
    telegram,
    snapchat,
    city,
    planId,
    footerPoweredBy,
    email
  } = data?.companyData || {};

  return (
    <Box
      pt={3}
      style={{
        // backgroundImage: `linear-gradient(to right, ${props.transparencyColor}, ${props.transparencyColor}), url(${props.image})`,
        backgroundImage: footerBackgroundColor ? `url(${image}), linear-gradient(${footerBackgroundColor}, ${footerBackgroundColor})` : `url(${image}), linear-gradient(rgba(17, 7, 41,1), rgba(17, 7, 41,1))`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        marginBottom: matches ? '0px' : '56px'
      }}
    >
      <Box width="90%" m="auto" px={2}>
        {/* menu buttons */}
        {visibleMenu ?
        <>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          textAlign="center"
          justifyContent="space-evenly"
          color={footerFontColor ? footerFontColor : "white"}
          width="calc(100% - 60px)"
          padding="16px 30px"
        >
          {menuList?.length > 2 ? 
            <>
              {React.Children.toArray(navItem2.map(v=> {
                  return(
                    <Typography>
                      <Link to={v.link}>
                        {v.title}
                      </Link>
                    </Typography>
                  )
              }))
              }
              {menuList?.splice(1)?.map((v,i)=> {
                  const { englishName, arabicName, visible, externalLink, path, id } = v;
                  
                  if(visible) return(
                    <MyLink 
                      key={i}
                      to={companyDomain ? `/temp/${id === 'service-1' ? 'services' : path}` : `/${pathId}/temp/${id === 'service-1' ? 'services' : path}`} 
                      externalLink={externalLink}
                      title={isRTL === 'ar' ? arabicName : englishName}
                    />
                  )
                })}
            </>
            : 
            // show default menu
            React.Children.toArray(navItem.map(v=> {
            return(
              <Typography>
                <Link to={v.link}>
                  {v.title}
                </Link>
              </Typography>
            )
            }))}
        </Box>
        <Divider style={{ backgroundColor: '#C7C5CD', margin: 'auto' }} />
        </>
        : null}

        {/* company info */}
        <Box
          py={3}
          display="flex"
          flexDirection={matches ? 'row' : 'column'}
          alignItems={matches ? 'flex-start' : 'center'}
          color={footerFontColor ? footerFontColor : "#C7C5CD"}
          opacity={0.7}
        >
          <Box width={matches ? '70%' : '100%'} mr={matches ? 2 : 0}>
            <Box
              m={matches ? 0 : 'auto'}
              pb={4}
              textAlign={matches ? 'left' : 'center'}
              width="fit-content"
            >
              <Typography
                variant="h3"
                style={{ fontWeight: 500,fontSize: !matches ? '1.4rem' : '3rem' }}
                align={!matches ? 'center' : isRTL === 'ar' ? 'right' : 'left'}
              >
                {t && t('companyPage.needMoreInformation')}
              </Typography>
            </Box>

            {(facebookPage || instagramPage || twitterPage || youtube || linkedin || tiktok || telegram || snapchat) && visibleSocialMedia ? (
              <Box
                pb={3}
                display={matches ? 'block' : 'flex'}
                flexDirection="column"
                alignItems="center"
              >
                <Box
                  mb={3}
                  width="fit-content"
                  borderBottom={`3px solid ${ footerFontColor ? footerFontColor : '#FAC400'}`}
                >
                  <Typography variant="subtitle1" style={{ color: footerFontColor ? footerFontColor : 'white' }}>
                    {t && t('companyPage.getInTouch')}
                  </Typography>
                </Box>
                <SocialIcons
                  color={footerFontColor ? footerFontColor : "white"}
                  mb={2}
                  border="1px solid white"
                  twitterLink={twitterPage}
                  youtubeLink={youtube}
                  facebookLink={facebookPage}
                  instagramLink={instagramPage}
                  linkedinLink={linkedin}
                  tiktokLink={tiktok}
                  telegramLink={telegram}
                  snapchatLink={snapchat}
                />
              </Box>
            ) : null}
          </Box>
          <Box dir='ltr' alignSelf={matches ? 'flex-start' : 'center'} pt={1}>
            {visibleMap ?
            <Box pb={!matches ? 1 : 3}>
              <Typography gutterBottom variant="subtitle1">
                {t && t('companyPage.address')}
              </Typography>
              <Typography
                variant="subtitle1"
                style={{ color: footerFontColor ? footerFontColor : 'white' }}
              >{footerAddress ? footerAddress : `${address} ${city}`}</Typography>
            </Box>
            : null }
            {visiblePhone ?
            <Box pb={!matches ? 1 : 3}>
              <Typography gutterBottom variant="subtitle1">
                {t && t('companyPage.phone')}
              </Typography>
              <a href={`tel:${phoneNumber}`}>
                <Typography variant="subtitle1" style={{ color: footerFontColor ? footerFontColor : 'white' }}>
                  {footerPhone ? footerPhone : phoneNumber}
                </Typography>
              </a>
            </Box>
            : null }
            {visibleEmail ?
            <Box pb={!matches ? 1 : 3}>
              <Typography gutterBottom variant="subtitle1">
                {t && t('companyPage.email')}
              </Typography>
              <a href={`mailto:${footerEmail ? footerEmail : email}`}>
                <Typography variant="subtitle1" style={{ color: footerFontColor ? footerFontColor : 'white' }}>
                  {footerEmail ? footerEmail : email}
                </Typography>
              </a>
            </Box>
            : null }
          </Box>
        </Box>
      </Box>

      <Divider style={{ backgroundColor: '#C7C5CD', margin: 'auto' }} />
      
      {/* term and conditions and payment method */}
      <Box
        display="flex"
        flexDirection={matches ? 'row' : 'column'}
        textAlign="center"
        alignItems="center"
        justifyContent="space-between"
        color="#000"
        width="calc(100% - 60px)"
        padding="10px 30px"
      >
        <Box
        display="flex"
        flexDirection='row'
        textAlign="center"
        alignItems="center"
        width={matches ? "40%" : "100%"}
        justifyContent={matches ? 'unset' : 'center'}
        visibility={footerLinks.length ? 'visible' : 'hidden'}
        >
          {
          React.Children.toArray(footerLinks.map((v,index)=> {
            if(v.link) {
              return (
                <>
                {v.isPath ? <Link to={v.link} style={{textDecoration:'none',color: footerFontColor ? footerFontColor : '#fff',cursor:'pointer',fontSize: matches ? '13px' : '10px' }}>{v.label}</Link> : <a href={v.link} target="_blank" style={{textDecoration:'none',color: footerFontColor ? footerFontColor : '#fff',cursor:'pointer',fontSize: matches ? '13px' : '10px' }}>{v.label}</a>}
                {index !== footerLinks.length -1 ? <Divider style={{width:'12px',backgroundColor: footerFontColor ? footerFontColor : '#fff',margin:'0px 10px'}} /> : null}
                </>
              )
            }
          }))
          }
        </Box>

        {visiblePaymentIcon ?
        <Box 
          width={matches ? "60%" : "100%"}
          display="flex"
          flexDirection="column"
          justifySelf={matches ? "flex-end" : "center"}
          alignItems={matches ? "flex-end": "center"}
          pt={matches ? '0px' : '3px'}
        >
          <div style={{width:'100%',display:'flex',flexDirection:'row',alignItems:'center',justifyContent: matches ? 'flex-end' : 'center'}}>
            {React.Children.toArray(paymentList.map(v=> (
              <ImgLazyLoad>
                <img src={iconList[v]} alt={v} style={{width:'100%',height:'30px'}}/>
              </ImgLazyLoad>

            )))}
          </div>
        </Box>
        : null}

      </Box>



      {/* copyright section */}
      {planId === 'free' || footerPoweredBy ?
      <>
      <Divider style={{ backgroundColor: '#C7C5CD', margin: 'auto' }} />
      <Box
        py={3}
        color={footerFontColor ? footerFontColor : "#C7C5CD"}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection={isRTL == 'ar' ? 'row-reverse' : 'row'}
      >
        {footerCopyright ?
        <Typography
          align="center"
          variant="subtitle2"
          style={{ marginRight: '0.6em' }}
          dir="ltr"
        >
          {footerCopyright}
        </Typography>
        :
        <>
        <Typography
          align="center"
          variant="subtitle2"
          style={{ marginRight: '0.6em' }}
          dir="ltr"
        >
          {t && t('companyPage.copyright',{year: new Date().getFullYear()})}
        </Typography>
        <Box
          height="25px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <ImgLazyLoad>
            <img src={Logo} alt="logo" style={{ height: '100%' }} />
          </ImgLazyLoad>
        </Box>
        </>
        }
      </Box>
      </>
      : null}
      
      {planId === 'free' ?
      <Box
        bgcolor="#fff"
        display="flex"
        flexDirection='column'
        textAlign="center"
        alignItems="center"
        justifyContent="center"
        color="#000"
        width="100%"
        padding="30px 0px"
      >

        <Typography style={{fontSize: '1rem'}}>
          Powered By : <a href="https://selynk.com" target="_blank" style={{textDecoration:'none',color:'#000',cursor:'pointer'}}>Selynk.com</a>
        </Typography>

        <div style={{width:"150px"}}>
          <ImgLazyLoad>
            <img src={Logo2} alt="selynk" width='100%' height='100%' />
          </ImgLazyLoad>
        </div>
        
        
        <Typography style={{fontSize: '1rem',fontWeight:'bold'}}>
        {t && t('companyPage.footerFree')} <a href="https://selynk.com" target="_blank" style={{textDecoration:'none',color:'#000',cursor:'pointer'}}>www.selynk.com</a>
        </Typography>
      </Box>
      : null
      }
      
    </Box>
  );
};

export default LongStyleFooter;

function MyLink({externalLink,to,title}) {
  
  return(
    externalLink ?
      <Typography>
        <a
          style={{
            textDecoration: 'none',
            color: 'inherit',
          }}
          href={externalLink}
        >
          {title}
        </a>
      </Typography>
    :
      <Typography>
        <Link to={to}>
          {title}
        </Link>
      </Typography>
  )
};